import { c as _c } from "react/compiler-runtime";
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input } from '@xefi/x-react/form';
import { useDebouncedValue } from '@xefi/x-react/hooks';
import { useParams, usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorHelper } from '@/app/(survey-taking)/_components/ErrorHelper';
import { useCanUserAnswerSurvey } from '@/app/(survey-taking)/_hooks/useCanUserAnswerSurvey';
import type { SurveyTaking } from '@/models/survey';
import { useMainStore } from '@/store';
import { emailRegex } from '@/utils/common';
type SurveyTakingAuthProps = {
  error?: string;
  values: {
    lastName?: string;
    firstName: string;
    email: string;
  };
  handleChange: (field: string, value: string) => void;
  currentSurvey?: SurveyTaking;
};
export const SurveyTakingAuth = t0 => {
  const $ = _c(58);
  const {
    error,
    values,
    handleChange,
    currentSurvey
  } = t0;
  const {
    t
  } = useTranslation();
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pathname?.includes("preview");
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isPreview = t1;
  const params = useParams();
  const surveyId = String(params?.surveyId ?? "");
  const searchParams = useSearchParams();
  let t2;
  if ($[2] !== searchParams) {
    t2 = searchParams?.get("entry_id");
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const entryIdParam = t2;
  const setCanUserAnswerSurvey = useMainStore(_temp);
  const {
    debouncedValue: debouncedEmail
  } = useDebouncedValue(values.email, 300);
  const {
    debouncedValue: debouncedFirstName
  } = useDebouncedValue(values.firstName ?? "", 300);
  const {
    debouncedValue: debouncedLastName
  } = useDebouncedValue(values.lastName ?? "", 300);
  let t3;
  if ($[4] !== debouncedEmail || $[5] !== debouncedFirstName || $[6] !== debouncedLastName || $[7] !== entryIdParam || $[8] !== isPreview || $[9] !== surveyId) {
    t3 = {
      surveyId,
      entryId: entryIdParam,
      email: debouncedEmail,
      firstname: debouncedFirstName,
      lastname: debouncedLastName,
      isPreview
    };
    $[4] = debouncedEmail;
    $[5] = debouncedFirstName;
    $[6] = debouncedLastName;
    $[7] = entryIdParam;
    $[8] = isPreview;
    $[9] = surveyId;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    data: validation,
    isLoading
  } = useCanUserAnswerSurvey(t3);
  const canUserAnswerSurvey = validation?.valid;
  const validationMessage = validation?.message;
  let t4;
  if ($[11] !== isPreview || $[12] !== setCanUserAnswerSurvey || $[13] !== validation?.valid) {
    t4 = () => {
      if (isPreview) {
        return;
      }
      setCanUserAnswerSurvey(validation?.valid ?? false);
    };
    $[11] = isPreview;
    $[12] = setCanUserAnswerSurvey;
    $[13] = validation?.valid;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isPreview || $[16] !== setCanUserAnswerSurvey || $[17] !== validation) {
    t5 = [setCanUserAnswerSurvey, validation, isPreview];
    $[15] = isPreview;
    $[16] = setCanUserAnswerSurvey;
    $[17] = validation;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  useEffect(t4, t5);
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FontAwesomeIcon icon={faUser} />;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t) {
    t7 = t("survey.authentication.title");
    $[20] = t;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t7) {
    t8 = <p className="flex items-center gap-3">{t6}{t7}</p>;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="bg-primary size-2 rounded-full" />;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("required", {
      ns: "common"
    });
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10) {
    t11 = <p className="flex items-center gap-2">{t9}{t10}</p>;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t8) {
    t12 = <div className="flex items-center justify-between p-4">{t8}{t11}</div>;
    $[29] = t11;
    $[30] = t8;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="bg-border h-px" />;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== error) {
    t14 = error && <ErrorHelper error={error} />;
    $[33] = error;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t || $[36] !== values.email) {
    t15 = values.email && !emailRegex.test(values.email) && <ErrorHelper error={t("validation.invalidEmail")} />;
    $[35] = t;
    $[36] = values.email;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = ["lastName", "firstName", "email"];
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== currentSurvey?.type || $[40] !== handleChange || $[41] !== t || $[42] !== values) {
    t17 = <div className="flex flex-col gap-4">{t16.map(fieldName => <Input radius="md" type="text" isDisabled={currentSurvey?.type.slug === "graded"} key={fieldName} name={`authentication_form.${fieldName}`} className="h-10" value={Object.entries(values).find(item => item[0] === fieldName)?.at(1)} onChange={event => handleChange(fieldName, event.target.value)} placeholder={t(`participant.${fieldName}`) || ""} />)}</div>;
    $[39] = currentSurvey?.type;
    $[40] = handleChange;
    $[41] = t;
    $[42] = values;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== canUserAnswerSurvey || $[45] !== isLoading || $[46] !== isPreview || $[47] !== t || $[48] !== validationMessage) {
    t18 = canUserAnswerSurvey === false && !isPreview && !isLoading && <p className="text-primary text-sm italic" id="email-already-use">{validationMessage ?? t("survey.authentication.emailExists")}</p>;
    $[44] = canUserAnswerSurvey;
    $[45] = isLoading;
    $[46] = isPreview;
    $[47] = t;
    $[48] = validationMessage;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== t14 || $[51] !== t15 || $[52] !== t17 || $[53] !== t18) {
    t19 = <div className="flex flex-col gap-6 p-6">{t14}{t15}{t17}{t18}</div>;
    $[50] = t14;
    $[51] = t15;
    $[52] = t17;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t12 || $[56] !== t19) {
    t20 = <div id="authentication" className="text-sm"><div className="border-border flex flex-col rounded-lg border">{t12}{t13}{t19}</div></div>;
    $[55] = t12;
    $[56] = t19;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  return t20;
};
function _temp(state) {
  return state.setCanUserAnswerSurvey;
}